<template>
  <div class="mask" @click.self="clickPopup('cancel')">
    <div class="popup">
      <h1>Please confirm the ticket type that tourist {{tour. name}} wants to choose？</h1>
      <ul>
        <li v-for="(item, index) in hitUsefulPersonInfo" @click="selectIndex(index)" :key="item.ticketKindSn + index">
          <span>{{ item.displayName }}</span>
          <img v-if="index === currentIndex" src="~@/assets/image/common/common_tick.png" alt="">
          <i v-else></i>
        </li>
      </ul>
      <div class="choice">
        <div @click="clickPopup('cancel')">cancel</div>
        <div @click="clickPopup('determine')">confirm</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "multiTicketDiversion",
  props: ['touristShuntSwitch', 'hitUsefulPersonInfo', 'tourist'],
  data() {
    return {
      currentIndex: 0
    }
  },
  methods: {
    clickPopup(type){
      this.$emit('clickPopup', {
        type,
        index: this.currentIndex,
      });
    },
    selectIndex(index){
      this.currentIndex = index;
    },
  }
};
</script>

<style scoped lang='less'>
.mask{
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.46);
  z-index: 9999;
};
.popup{
    width: 4.666667rem * 2;
    background: #FFFFFF;
    border-radius: .08rem * 2;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h1{
      font-size: .24rem * 2;
      color: #222328;
      line-height: .666667rem;
      font-weight: bold;
      padding: .466667rem 0;
    }
    ul{
      li{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .4rem;
        span{
          font-size: .48rem;
          color: #000000;
          line-height: 1.066667rem;
          letter-spacing: .026667rem;
        }
        img{
          height: .586667rem;
        }
        i{
          width: .586667rem;
          height: .586667rem;
          border-radius: 50%;
          border: 1px solid rgba(153, 153, 153, .5);
          flex-shrink: 0;
        }
      }
    }
    .choice{
      display: flex;
      justify-content: space-between;
      padding: .4rem;
      div{
        width: 4rem;
        line-height: 1.133333rem;
        border-radius: .16rem;
        color: #FFFFFF;
        font-weight: bold;
        font-size: .533333rem;
        &:first-child{
          background: #A1A6BA;
        }
        &:last-child{
          background: #3B6D9C;
        }
      }
    }
  }
</style>
